import React, { PureComponent } from 'react';

import Accordion from '@opendoor/bricks/deprecated/UNSAFE_Accordion';
import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';

import { ContentWrapper } from './ContentWrapper';

interface IFAQ {
  answer: Exclude<React.ReactNode, null | undefined>;
  question: Exclude<React.ReactNode, null | undefined>;
}

interface IFaqSectionProps {
  faqs: Array<IFAQ>;
}

class FaqSection extends PureComponent<IFaqSectionProps> {
  public render() {
    const { faqs } = this.props;

    return (
      <ContentWrapper>
        <ContentCard title="FAQs" borderRadius="roundedSquare">
          <Accordion
            alignBody={true}
            items={faqs.map((faq) => ({
              body: faq.answer,
              id: faq.question.toString(),
              title: faq.question,
            }))}
            multiExpand={true}
            noBorder={true}
          />
        </ContentCard>
      </ContentWrapper>
    );
  }
}

export default FaqSection;
